import { CustomLevel } from '@/common/types/customLevel';
import {
  DotsThreeVerticalIcon,
  JoystickIcon,
  PencilSimpleIcon,
  TrashIcon,
} from '@phosphor-icons/react';
import { Button } from '@shadcn/components/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@shadcn/components/dropdown-menu';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface CustomLevelCardProps {
  customLevel: CustomLevel;
  onConfirmDelete: () => void;
}

export default function CustomLevelCard({
  customLevel,
  onConfirmDelete,
}: CustomLevelCardProps) {
  const navigate = useNavigate();
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  function handleNavigate() {
    navigate(`/dashboard/customlevels/${customLevel.id}`);
  }

  return (
    <div
      className="group relative bg-white rounded-lg border border-gray-200 overflow-hidden cursor-pointer hover:bg-gray-50 transition-colors"
      onClick={handleNavigate}
    >
      <div className="relative flex items-center justify-center h-32 bg-gradient-to-br from-violet-100 to-indigo-100">
        <JoystickIcon
          size={24}
          weight="duotone"
          className="absolute bottom-2 left-2 text-gray-600 opacity-60"
        />
      </div>

      <div className="p-3 border-t border-gray-100">
        <div className="flex items-start justify-between gap-2">
          <div className="flex-1 min-w-0">
            <h3 className="font-medium text-sm text-gray-900 truncate">
              {customLevel.description || 'Untitled Level'}
            </h3>
            <span className="text-xs text-gray-500">
              {dayjs(customLevel.updatedAt).fromNow()}
            </span>
          </div>

          <DropdownMenu open={isDropdownOpen} onOpenChange={setDropdownOpen}>
            <DropdownMenuTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                className="h-8 w-8 opacity-0 group-hover:opacity-100 transition-opacity"
                onClick={(e) => e.stopPropagation()}
              >
                <DotsThreeVerticalIcon size={18} />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              align="end"
              onClick={(e) => e.stopPropagation()}
            >
              <DropdownMenuItem
                className="flex gap-2"
                onClick={() => {
                  setDropdownOpen(false);
                  handleNavigate();
                }}
              >
                <PencilSimpleIcon size={16} /> Edit
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                className="flex gap-2 text-red-600"
                onClick={() => {
                  setDropdownOpen(false);
                  onConfirmDelete();
                }}
              >
                <TrashIcon size={16} /> Delete
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </div>
  );
}
